import { Mail, CalendarDays, ListChecks, Bell, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const Panel = ({ step, title, children, testId }) => (
  <div data-testid={testId} className="rounded-3xl border border-dashed border-[#B9C3D6] bg-[#FAF7F2] p-6">
    <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#5A6176]">{step}</p>
    <p className="font-display mt-2 text-xl text-[#16203A]">{title}</p>
    <div className="mt-5 space-y-3">{children}</div>
  </div>
);

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3 rounded-2xl bg-[#EFEBE3] px-4 py-3">
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-[#1C2B4A]" />
    <div className="text-sm leading-snug">
      <p className="font-semibold text-[#16203A]">{label}</p>
      <p className="text-[#464E62]">{value}</p>
    </div>
  </div>
);

const Arrow = () => (
  <div className="flex justify-center text-[#3D5585] lg:items-center" aria-hidden="true">
    <ArrowRight className="h-5 w-5 rotate-90 lg:rotate-0" />
  </div>
);

export const Example = () => (
  <section className="px-3 sm:px-6" data-testid="example-section">
    <div className="mx-auto max-w-7xl rounded-[2.5rem] bg-[#F2ECE1] px-5 py-16 sm:px-12 sm:py-20">
      <div className="mx-auto max-w-5xl">
        <Reveal>
          <h2 data-testid="example-label" className="font-display text-3xl font-normal leading-[1.15] tracking-tight text-[#16203A] sm:text-4xl">
            An example of how Otti will help
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 grid select-none gap-4 lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:gap-5" aria-label="Illustration with fictional details">
            <Panel step="1 · Comes in" title="A school message" testId="example-panel-message">
              <Row icon={Mail} label="From: Maple Grove School" value="Swimming gala on Thursday at 2pm. Please arrange a lift to the pool." />
            </Panel>
            <Arrow />
            <Panel step="2 · Added to Otti" title="An event and a task" testId="example-panel-plan">
              <Row icon={CalendarDays} label="Event" value="Swimming gala · Thursday, 2pm" />
              <Row icon={ListChecks} label="Task" value="Transport to the pool · Sam is taking care of it" />
            </Panel>
            <Arrow />
            <Panel step="3 · Follow-through" title="A reminder for Sam" testId="example-panel-reminder">
              <Row icon={Bell} label="Reminder to Sam" value="Transport to the swimming gala, Thursday at 1:30pm." />
            </Panel>
          </div>
        </Reveal>
        <p data-testid="example-fictional-note" className="mt-6 text-sm text-[#5A6176]">Names and details are fictional.</p>
      </div>
    </div>
  </section>
);
